import { render, staticRenderFns } from "./CargoComponentView.vue?vue&type=template&id=358e4639&"
import script from "./CargoComponentView.vue?vue&type=script&lang=js&"
export * from "./CargoComponentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports